import { IconProps } from './IconProps';
export function IllustrationPenPaper(props: IconProps) {
    return (
        <svg
            {...props}
            width="133"
            height="83"
            viewBox="0 0 133 83"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M69.9854 60.684C60.8485 41.2349 52.7399 21.3059 45.7073 1C36.173 5.34222 28.1534 8.50206 19.8562 10.5584C17.0048 11.2644 14.0986 11.847 11.4254 13.0568C7.58015 14.7978 4.42031 17.7314 1 21.7789C8.27244 30.2851 12.1725 41.0875 15.9287 51.6295C19.6026 61.9452 23.2766 72.2576 28.1534 82.3129C42.2322 75.839 56.1053 68.9264 69.9854 60.684Z"
                fill="#E5EDFF"
                stroke="#121A44"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6172 27.9081C15.2157 24.2616 20.3427 22.6714 25.1922 21.0126C31.4947 18.8569 37.6842 16.3723 43.7263 13.5723"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.0703 33.4634C24.8343 28.3227 34.8725 23.6994 45.1231 19.6211"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5078 39.9813C19.8451 38.1067 22.6246 36.8866 25.3697 35.6871C33.1665 32.2805 40.9633 28.8705 48.7601 25.4639"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.5703 47.3087C30.359 43.1687 40.8119 38.1616 50.8021 32.3525"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.6328 53.425C34.1336 49.4187 44.4597 44.9599 54.5733 40.0625"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.1484 61.3465C36.0125 56.5725 46.8767 51.7985 57.7442 47.0244"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.625 68.1838C36.8056 64.479 44.9829 60.7743 53.1635 57.0695C55.4803 56.0208 57.8244 54.955 59.8088 53.3613"
                stroke="#0047FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M118.713 17.2127C110.232 36.3284 100.228 57.96 90.5405 76.2017C88.9424 78.4597 87.096 80.037 84.9453 82.3086C85.2963 79.6306 85.9215 74.6678 86.3488 73.7636C91.7548 62.2225 110.164 26.6684 114.702 15.309C116.223 16.0424 117.837 16.3583 118.713 17.2127Z"
                stroke="#121A44"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.4313 76.0831C90.5672 75.8344 90.3958 75.4932 90.1279 75.4017C89.86 75.3102 89.5526 75.4332 89.3637 75.6454C89.5453 75.2628 89.5002 74.7383 89.1574 74.487C88.8145 74.2357 88.2032 74.4651 88.2095 74.8905C88.2864 74.6266 88.3666 74.3461 88.294 74.0799C88.2214 73.8136 87.9322 73.5869 87.6776 73.6877C87.4256 73.7838 87.351 74.1137 87.1418 74.2805C87.2061 74.0278 87.2154 73.7314 87.0443 73.5352C86.8732 73.3389 86.4714 73.374 86.419 73.6274"
                stroke="#121A44"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M115.939 23.383C114.789 22.4858 113.398 21.8974 111.952 21.6962"
                stroke="#121A44"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M88.6329 78.9224L85.5504 77.4982L84.9922 82.1182L88.6329 78.9224Z"
                fill="#0047FF"
            />
        </svg>
    );
}
